import { combineReducers } from 'redux'
import { Reducer } from 'interfaces'
import { PublicDashboardDataState } from 'interfaces/publicDashboard'
import {
  GET_PUBLIC_BREAKDOWN_BY_STATE,
  GET_PUBLIC_BREAKDOWN_BY_CATEGORY,
  GET_PUBLIC_BREAKDOWN_BY_MERCHANT,
  GET_PUBLIC_TREND,
} from 'actions/publicDashboardActions'
import { createFetchableReducer, createEmptyFetchable } from 'helpers/loadableHelpers'

const trendFetchableReducer = createFetchableReducer<NonNullable<PublicDashboardDataState['trend']['data']>>()
const trend: Reducer<PublicDashboardDataState['trend']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case GET_PUBLIC_TREND: {
      return trendFetchableReducer(prevState, action)
    }
  }
  return prevState
}

const breakdownByStateFetchableReducer = createFetchableReducer<NonNullable<PublicDashboardDataState['breakdownByState']['data']>>()
const breakdownByState: Reducer<PublicDashboardDataState['breakdownByState']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case GET_PUBLIC_BREAKDOWN_BY_STATE: {
      return breakdownByStateFetchableReducer(prevState, action)
    }
  }
  return prevState
}

const breakdownByCategoryFetchableReducer = createFetchableReducer<NonNullable<PublicDashboardDataState['breakdownByCategory']['data']>>()
const breakdownByCategory: Reducer<PublicDashboardDataState['breakdownByCategory']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case GET_PUBLIC_BREAKDOWN_BY_CATEGORY: {
      return breakdownByCategoryFetchableReducer(prevState, action)
    }
  }
  return prevState
}

const breakdownByMerchantFetchableReducer = createFetchableReducer<NonNullable<PublicDashboardDataState['breakdownByMerchant']['data']>>()
const breakdownByMerchant: Reducer<PublicDashboardDataState['breakdownByMerchant']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case GET_PUBLIC_BREAKDOWN_BY_MERCHANT: {
      return breakdownByMerchantFetchableReducer(prevState, action)
    }
  }
  return prevState
}

export const publicDashboardDataReducer = combineReducers<PublicDashboardDataState>({
  trend,
  breakdownByState,
  breakdownByCategory,
  breakdownByMerchant,
})
